import * as api from '../../services/guess'
import lodash from 'lodash'

export const FETCH_GUESSS= 'FETCH_GUESSS';
export const FETCH_GUESSGOODS= 'FETCH_GUESSGOODS';
export const FETCH_GUESSRANKINGLIST= 'FETCH_GUESSRANKINGLIST';





export const fetchGuesss = (params, pagination, sort, extra) => {

    return {
        type: FETCH_GUESSS,
        payload: {
            promise: api.findGuesss(Object.assign({}, params, {page: pagination ? pagination.current : 1, pageSize: pagination ? pagination.pageSize : 20})),
        },
        meta: {
            searchParams: lodash.omit(params, 'ownership'),
            sort: sort,
            extra: extra
        }
    };
};

export const fetchGuessGoods = (params, pagination, sort, extra) => {

    return {
        type: FETCH_GUESSGOODS,
        payload: {
            promise: api.findGuessGoods(Object.assign({}, params, {page: pagination ? pagination.current : 1, pageSize: pagination ? pagination.pageSize : 20})),
        },
        meta: {
            searchParams: lodash.omit(params, 'ownership'),
            sort: sort,
            extra: extra
        }
    };
};

export const fetchGuessRankingList = (params, pagination, sort, extra) => {

    return {
        type: FETCH_GUESSRANKINGLIST,
        payload: {
            promise: api.findGuessRankingList(Object.assign({}, params, {page: pagination ? pagination.current : 1, pageSize: pagination ? pagination.pageSize : 20})),
        },
        meta: {
            searchParams: params,
            sort: sort,
            extra: extra
        }
    };
};



// WEBPACK FOOTER //
// ./src/redux/actions/guess.js